import React from 'react';
import BapProgressBar from './BapProgressBar';
import InventoryProgressBar from './InventoryProgressBar';
import NotImplemented from '../NotImplemented';
import { ACURA_SITE_NAME, HONDA_SITE_NAME } from '../../utils/constants';
import { useAppName } from '../../utils/sitecoreContext';
import { variant1, variant2 } from './constants';
const ProgressBarMap = ({ fields, params }) => {
    var _a;
    const appName = useAppName();
    let variant;
    switch (appName) {
        case HONDA_SITE_NAME:
            variant = variant1;
            break;
        case ACURA_SITE_NAME:
            variant = variant2;
            break;
        default:
            return React.createElement(NotImplemented, { name: "Progress Bar" });
    }
    if (((_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null) {
        return null;
    }
    const mode = params === null || params === void 0 ? void 0 : params.variant;
    switch (mode) {
        case 'variant1':
            return React.createElement(BapProgressBar, { variant: variant, fields: fields });
        case 'variant2':
            return React.createElement(InventoryProgressBar, { variant: variant, fields: fields });
        default:
            return React.createElement(BapProgressBar, { variant: variant, fields: fields });
    }
};
export default ProgressBarMap;
